import React from 'react'
import { Instance } from 'tippy.js'
import Tippy, { TippyProps } from '@tippyjs/react'
import { ValidationIssue } from 'api'
import { getErrorMessages, getErrorMessagesByField } from 'model'
import './ValidationTooltip.css'

export const VALIDATION_TOOLTIP_OPTIONS = {
  trigger: 'mouseenter focus',
  delay: 500,
  maxWidth: 800,
  arrow: true,
  offset: [0, 6],
  allowHTML: true
}

export interface ValidationTooltipProps {
  validationIssues: ValidationIssue[]
  showField?: boolean
  children?: React.ReactNode
}

export class ValidationTooltip extends React.PureComponent<ValidationTooltipProps> {
  componentDidMount() {
    this.updateTippy()
  }

  componentDidUpdate() {
    this.updateTippy()
  }

  render() {
    const { validationIssues, showField, children } = this.props
    const messages = showField ? getErrorMessagesByField(validationIssues) : getErrorMessages(validationIssues)

    return (
      <Tippy
        {...(VALIDATION_TOOLTIP_OPTIONS as TippyProps)}
        content={getTooltipContent(messages)}
        disabled={validationIssues.length === 0}
        onCreate={this.handleCreate}>
        {children as React.ReactElement<any>}
      </Tippy>
    )
  }

  private instance: Instance | null = null

  private handleCreate = (instance: Instance) => {
    this.instance = instance
  }

  public get tippy(): Instance | null {
    return this.instance
  }

  private updateTippy() {
    /* We need to do this manually because of https://github.com/atomiks/tippy.js-react/pull/91 */
    if (this.instance) {
      if (this.props.validationIssues.length > 0) {
        this.instance.enable()
      } else {
        this.instance.enable()
        this.instance.hide()
        this.instance.disable()
      }
    }
  }
}

export function getTooltipContent(messages: string[]) {
  const contentItems = messages.map((msg, idx) => (
    <li key={idx} className="tooltip-content-item">
      {msg}
    </li>
  ))
  return <ul className="tooltip-content-list">{contentItems}</ul>
}

export function getTooltipHtml(messages: string[]): string {
  const contentItems = messages.map(msg => `<li class="tooltip-content-item">${msg}</li>`).join('')
  return `<ul class="tooltip-content-list">${contentItems}</ul>`
}
